//#region src/extensions/image-extension/utils/get-container-width-from-element.ts
var e = (e) => e.style.cssText ? e.style.cssText.split(";").map((e) => e.trim()).find((e) => e.startsWith("width"))?.split(":")[1]?.trim() ?? "auto" : "auto";
//#endregion
export { e as getContainerWidthFromElement };
